import React, { memo } from 'react';

import MaterialTextField from '../../MaterialTextField/MaterialTextField';
import { useLoadInfoField } from './useLoadInfoField';
import { useStyles } from './useStyles';

export const LoadInfoField = memo((props) => {
    const { loadInfo, recordId, name, defaultValue, onChangeValue, required, validator } = props;

    const { value, errorText, handleChange, handleInfoChange, handleInputFocus } = useLoadInfoField(
        loadInfo,
        recordId,
        name,
        defaultValue,
        onChangeValue,
        required,
        validator
    );

    const classes = useStyles();

    return (
        <MaterialTextField
            label=""
            placeholder="0"
            name={name}
            fullWidth={true}
            value={value}
            onChange={handleChange}
            onBlur={handleInfoChange}
            onFocus={handleInputFocus}
            className={classes.field}
            helperText={errorText}
            error={Boolean(errorText)}
            inputProps={{ className: classes.input }}
            type="number"
        />
    );
});

LoadInfoField.displayName = 'LoadInfoField';
